import React from 'react';
import Layout from '../../components/Layout';

import TermURLTable from './termURLTable';
import URLTable from './urlTable';
import Warn from '../warn';

const AILogsPage = () => {
  return (
    <Layout>
      <p className="text-sm text-gray-600 mb-6 max-w-3xl mx-auto text-center">
        Scan logs show reverse-image and term search results for monitored artworks.
        Warnings appear when a match is found on a tracked auction site.
      </p>
      <div className="flex flex-col lg:flex-row gap-8 justify-center items-start">
        <div className="w-full lg:w-[48%] text-center">
          <h1 className="text-red-500 font-extrabold mb-2">Image scan log</h1>
          <p className="text-xs text-gray-500 mb-3">Reverse-image matches per artwork</p>
          <URLTable />
        </div>
        <div className="w-full lg:w-[48%] text-center">
          <h1 className="text-red-500 font-extrabold mb-2">Term scan log</h1>
          <p className="text-xs text-gray-500 mb-3">Title/keyword matches per artwork</p>
          <TermURLTable />
        </div>
      </div>
      <div className="text-center mt-10">
        <Warn />
      </div>
    </Layout>
  );
};

export default AILogsPage;
